import type { RssImageCreditTag } from './resolveRssImageCredit';

export type RssImageCaptionTag = 'media:description' | 'media:title' | 'figcaption';

export type ResolveRssImageCaptionParams = {
  imageCaptionTag?: RssImageCaptionTag | null;
  imageCreditTag?: RssImageCreditTag | null;
  thumbnailCaption?: string | null;
  thumbnailMediaTitle?: string | null;
  thumbnailFigcaption?: string | null;
};

// Mirrors RSS_IMAGE_CAPTION_FALLBACK_TAGS in app/services/tiptap/components/shared/rss_methods.rb
const FALLBACK_CAPTION_TAGS: RssImageCaptionTag[] = ['media:description', 'figcaption'];

export const resolveRssImageCaption = ({
  imageCaptionTag,
  imageCreditTag,
  thumbnailCaption,
  thumbnailMediaTitle,
  thumbnailFigcaption,
}: ResolveRssImageCaptionParams): string | undefined => {
  const fieldsByTag: Record<RssImageCaptionTag, string | null | undefined> = {
    'media:description': thumbnailCaption,
    'media:title': thumbnailMediaTitle,
    figcaption: thumbnailFigcaption,
  };
  const fallbackTags = FALLBACK_CAPTION_TAGS.filter((tag) => tag !== imageCreditTag);
  const tags = [imageCaptionTag || 'media:description', ...fallbackTags];

  for (const tag of tags) {
    const value = fieldsByTag[tag]?.trim();
    if (value) return value;
  }

  return undefined;
};
